"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var _AnalyticsExportDestination_1 = require("./_AnalyticsExportDestination");
exports._StorageClassAnalysisDataExport = {
    type: "structure",
    required: ["OutputSchemaVersion", "Destination"],
    members: {
        OutputSchemaVersion: {
            shape: {
                type: "string"
            }
        },
        Destination: {
            shape: _AnalyticsExportDestination_1._AnalyticsExportDestination
        }
    }
};
//# sourceMappingURL=_StorageClassAnalysisDataExport.js.map